var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEscalator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0v24H0V0zM12.594 23.258l-.012.002-.071.035-.02.004-.014-.004-.071-.036c-.01-.003-.019 0-.024.006l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113-.014.002-.184.093-.01.01-.003.011.018.43.005.012.008.008.201.092c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.003-.011.018-.43-.003-.012-.01-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09244BFF",
    d: "M18 3.172a1 1 0 0 1 1 1v3.242L19.414 7a1 1 0 1 1 1.414 1.414l-2.12 2.122a1 1 0 0 1-1.415 0l-2.121-2.122A1 1 0 1 1 16.586 7l.414.414V4.172a1 1 0 0 1 1-1M2 7a3 3 0 0 1 3-3h3.039a3 3 0 0 1 2.342 1.126l7.1 8.874H19a3 3 0 1 1 0 6h-3.039a3 3 0 0 1-2.342-1.126L6.519 10H5a3 3 0 0 1-3-3m18 10a1 1 0 0 0-1-1h-2a1 1 0 0 1-.78-.375l-7.4-9.25A1 1 0 0 0 8.039 6H5a1 1 0 1 0 0 2h1.76a1.5 1.5 0 0 1 1.171.563l7.25 9.062a1 1 0 0 0 .78.375H19a1 1 0 0 0 1-1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEscalator);
export default __webpack_public_path__ + "static/media/Ic_escalator.1cf22e1c40f6f965668b211976c7d73e.svg";
export { ForwardRef as ReactComponent };